import type React from "react";
import { NavLink, type NavLinkProps } from "react-router-dom";

interface ConditionalNavLinkProps extends NavLinkProps {
  isDisabled?: boolean;
  className?: string;
  children: React.ReactNode;
}

export const ConditionalNavLink: React.FC<ConditionalNavLinkProps> = ({
  isDisabled = false,
  className = "",
  children,
  ...props
}) => {
  if (isDisabled) {
    return (
      <NavLink
        className={`${className}`}
        {...props}
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          props.onClick?.(e);
        }}
        style={{ cursor: "not-allowed" }}
      >
        {children}
      </NavLink>
    );
  }

  return (
    <NavLink
      className={({ isActive }) => (isActive ? `${className} active` : className)}
      {...props}
    >
      {children}
    </NavLink>
  );
};
